import { isNotNil } from '@/helpers/lodash-ext'
import { connectFunctionsEmulator, getFunctions } from '@firebase/functions'
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'

import { getStorage } from 'firebase/storage'
import envFirebaseConfig from './envFirebaseConfig'

// Initialize Firebase
const firebaseConfig = envFirebaseConfig()
const app = initializeApp(firebaseConfig)

console.log('Start Firebase 🔥', import.meta.env.MODE)

// Auth
export const auth = getAuth()
export const uid = () => auth.currentUser?.uid || null
export const email = () => auth.currentUser?.email || null
export const getTeamClaims = async (): Promise<{
  teamIds: string[]
  currentTeamId: string | null
}> => {
  const idToken = await auth.currentUser?.getIdTokenResult(true)
  return {
    teamIds: (idToken?.claims?.teamIds ?? []) as string[],
    currentTeamId: (idToken?.claims?.currentTeamId ?? null) as string | null
  }
}

export const getCurrentTeamId = async (): Promise<string> => {
  const { currentTeamId } = await getTeamClaims()
  return currentTeamId!
}

export const isLoggedIn = () => isNotNil(uid())

export const store = getFirestore()
export const storage = getStorage()
export const functions = getFunctions(app, 'asia-northeast1')
if (import.meta.env.VITE_APP_USE_EMULATOR === 'true') {
  console.log('🔥Firebase use firestore emulator')
  console.log('Functions host', import.meta.env.VITE_APP_CLOUD_FUNCTION_URL)
  console.log(
    'Firestore host',
    import.meta.env.VITE_APP_FIRE_STORE_EMULATOR_HOST
  )
  connectFirestoreEmulator(store, location.hostname, 5002)
  connectAuthEmulator(auth, `http://${location.hostname}:5004`)
  connectFunctionsEmulator(functions, location.hostname, 5001)
}
